import { lookupsStore } from 'src/stores/lookups';

const finalStatuses = ['CANCELED', 'COMPLETED', 'INVOICED'];

export const isFinalisedSOStatus = (statusId: number) =>
  lookupsStore.serviceOrderStatuses
    .filter(({ matchingText }) => finalStatuses.includes(matchingText))
    .map(({ key }) => key)
    .includes(statusId.toString());
